import "core-js/modules/es.array.push.js";
import { format } from 'date-fns';
var _data = [];
var beginDay = new Date().getTime();
var fakeY = [7, 5, 4, 2, 4, 7, 5, 6, 5, 9, 6, 3, 1, 5, 3, 6, 5];
for (var i = 0; i < fakeY.length; i += 1) {
  _data.push({
    x: format(new Date(beginDay + 1000 * 60 * 60 * 24 * i), 'yyyy-MM-dd'),
    y: fakeY[i]
  });
}
var tooltip = ['x*y', function (x, y) {
  return {
    name: x,
    value: y
  };
}];
var scale = [{
  dataKey: 'x',
  min: 2
}, {
  dataKey: 'y',
  title: '时间',
  min: 1,
  max: 22
}];
export default {
  name: 'MiniArea',
  data: function data() {
    return {
      data: _data,
      scale: scale,
      tooltip: tooltip,
      height: 100
    };
  }
};